//try this https://betterprogramming.pub/loading-third-party-scripts-dynamically-in-reactjs-458c41a7013d
import React from "react";
import {graphql, Link} from "gatsby";
import styled, {css} from "styled-components";

import PageLayout from "@acc-monorepo/gatsby-stories-acc/national/layout/PageLayout";
import {BackgroundImage} from "@acc-monorepo/gatsby-stories/styles/shared";
import HeadSeo from "@acc-monorepo/gatsby-stories/seo/HeadSeo";
import {Container, Section} from "@acc-monorepo/gatsby-stories-acc/national/style/national";
import VimeoVideo from "@acc-monorepo/gatsby-stories/video/VimeoVideo";

import BackgroundPattern from "../../content/images/excelencia-live/2023/excelencia-pattern-nogradient.png";
// import VimeoVideo from "@acc-monorepo/gatsby-stories/video/VimeoVideo";
import EventImage from "../../content/images/excelencia-live/2023/excelencia-23-event.jpg";
import Logo from "../../content/images/excelencia-live/2023/logo.png";
// import Button from "@acc-monorepo/gatsby-stories-acc/buttons/Button";

// import OpenLinkSvg from "../../content/images/icons/open-link.svg";
// import GoogleDriveIcon from "../../content/images/icons/google-drive.png";
import TobyImage from "../../content/images/excelencia-live/2023/toby.jpg";
import AshleyImage from "../../content/images/excelencia-live/2023/ashley.jpg";


const pageStyles = css`
  --content-width-max: 1000px;

  text-align: center;

  h2 {
    font-weight: 600;
    color: #0169b4;
    font-size: 1.75rem;
    line-height: 1.25;
  }

  h3 {
    color: #0169b4;
    margin-top: 1rem;
  }

  section {
    padding: 4rem 0;
  }

  .blue-pattern-bkg {
    background-image: linear-gradient(168deg, rgba(153, 181, 205, 0.42), rgba(11, 17, 41, 0.82)), url(${BackgroundPattern});
    background-repeat: repeat;
    background-position: top center;
    color: white;

    p {
      color: white;
    }
  }

  @media (min-width: 768px) {
    h2 {
      font-size: 2rem;
    }
  }
`

const HostSection = styled(Section)`
  .speakers {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;

    .speaker img, .speaker .placeholder {
      border-radius: 100%;
      width: 200px;
      height: 200px;
      margin-top: 2rem;
    }

    .speaker .placeholder {
      display: inline-block;
      background-color: lightslategrey;
    }
  }

  @media (min-width: 768px) {
    ${Container} {
      padding: 0;
    }

    .speakers {
      margin-top: 2rem;
      display: flex;
      flex-direction: row;

      .speaker {
        width: 50%;
        margin-bottom: 2rem;
        padding: 0 2rem;

        img {
          margin-top: 0;
        }
      }
    }
  }
`

const TitleSection = styled.div`
  width: 100%;
  padding: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 55vh;
  max-height: 600px;
  overflow: hidden;
  background-color: #000000;

  ${BackgroundImage} {
    opacity: 0.4;
  }

  .title-wrapper {
    height: 100%;
    max-height: 100%;
    //width: calc(95% - 4rem);
    //max-width: 400px;
    flex-grow: 0;
    z-index: 1;

    img {
      display: block;
      height: 100%;
      object-fit: cover;
    }
  }
`

// const ButtonContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//
//   @media (min-width: 768px) {
//     /* Adjust the min-width as needed for your desktop breakpoint */
//     flex-direction: row;
//     justify-content: center;
//     gap: 1rem; /* This sets the space between the buttons */
//   }
// `;
//
// const VideoEmbedColumns = styled(Container)`
//   display: flex;
//   flex-direction: column;
//   @media (min-width: 768px) {
//     flex-direction: row;
//     padding: 0;
//     .column {
//       width: 50%;
//       flex: 1;
//
//       &:first-child {
//         flex: 1 1 64%;
//       }
//
//       &:last-child {
//         flex: 1 1 36%;
//       }
//     }
//   }
// `
//
// const ResponsiveIframeWrapper = styled.div`
//   position: relative;
//   overflow: hidden;
//   padding-top: 56.25%;
//
//   iframe {
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     width: 100%;
//     height: 100%;
//     margin: 0;
//     border: 0;
//   }
//
//   @media (min-width: 768px) {
//     &.chat {
//       //padding-top: 111.55%; /* Works for flex basis 66% 33% */
//       padding-top: 100%; /* Works for flex basis 66% 33% */
//     }
//   }
// `

// const WatchPartyTitle = styled.h2`
//   //font-size: 1.5rem;
//   margin-top: 0;
//   margin-bottom: 1.5rem;
// `


// const WatchPartyImage = styled(GatsbyImage)`
//   width: 100%;
//   min-height: 130px;
//   border-radius: 1rem;
//   margin-bottom: 0.25rem;
//
//   @media (min-width: 768px) {
//     border-radius: 1.5rem;
//   }
// `
//
// const TimeContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   gap: 1rem;
//   margin-top: 1rem;
//
//   @media (min-width: 768px) {
//     /* Adjust the min-width as needed for your desktop breakpoint */
//     flex-direction: row;
//     justify-content: space-evenly;
//     align-items: flex-start;
//   }
// `;


// const TimezoneHeading = styled.h3`
//   color: #0169b4;
//   margin-top: 0;
//   margin-bottom: 1rem;
// `;
//
// const Time = styled.p`
//   margin: 0;
//   font-weight: bold;
// `;

// const TimezoneSection = ({state, time}) => (
//   <div>
//     <TimezoneHeading>{state}</TimezoneHeading>
//     <Time>{time}</Time>
//   </div>
// );


const ExcelenciaLivePage = (props) => {
  const {data} = props;

  return (
    <PageLayout css={pageStyles}>
      <TitleSection>
        <BackgroundImage
          image={data.featureImage.childImageSharp.gatsbyImageData}
          alt="Distance education primary school student reading a book outside with her pet chicken"
          loading="eager"
        />
        <div className="title-wrapper">
          <img src={Logo} alt="Excelencia Live 2023"/>
        </div>
      </TitleSection>

      <Section>
        <Container>
          <p>
            Welcome to Excelencia Live 2023! This special online event, hosted by students for students, showcases short presentations from the talented individuals featured in the annual Excelencia printed journal.
          </p>
          <p style={{margin: 0}}>
            The event was held online on Wednesday 15th November 2023.
          </p>
        </Container>

        {/*<Container>*/}
        {/*    <p>&nbsp;</p>*/}
        {/*    <p>Use a button below to add it to your own calendar.</p>*/}
        {/*    <ButtonContainer>*/}
        {/*        <Button style={{padding: "0.7em 1.6em", lineHeight: 2}} href="https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20231115T000000Z%2F20231115T013000Z&details=Excelencia%20Live%202023%21%0A%0AThis%20special%20online%20event%2C%20hosted%20by%20students%20for%20students%2C%20showcases%20short%20presentations%20from%20the%20talented%20individuals%20featured%20in%20the%20annual%20Excelenica%20printed%20journal.%0A%0AJoin%20us%20in%20the%20chat.%0A%0AFrom%20our%20website%3A%0Ahttps%3A%2F%2Fwww.acc.edu.au%2Fexcelencia-live%2F%0A%0AOr%20straight%20from%20youtube%3A%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DA_6KRfOStn4&location=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DA_6KRfOStn4&text=Excelencia%20Live%202023">*/}
        {/*            <img*/}
        {/*                alt="Gmail Icon"*/}
        {/*                src="https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_10_2x.png"*/}
        {/*                style={{display: "inline-block", height: "2em", width: "2em", verticalAlign: "middle", border: 0, margin: "-0.5em 0", padding: 0, outline: 0}}*/}
        {/*            />&nbsp; &nbsp;Add to Google Calendar*/}
        {/*        </Button>*/}
        {/*        <Button style={{padding: "0.7em 1.6em", lineHeight: 2}} href="https://outlook.live.com/calendar/0/action/compose?body=Excelencia%20Live%202023%21%0A%0AThis%20special%20online%20event%2C%20hosted%20by%20students%20for%20students%2C%20showcases%20short%20presentations%20from%20the%20talented%20individuals%20featured%20in%20the%20annual%20Excelenica%20printed%20journal.%0A%0AJoin%20us%20in%20the%20chat.%0A%0AFrom%20our%20website%3A%0Ahttps%3A%2F%2Fwww.acc.edu.au%2Fexcelencia-live%2F%0A%0AOr%20straight%20from%20youtube%3A%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DA_6KRfOStn4&enddt=2023-11-15T01%3A30%3A00%2B00%3A00&location=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DA_6KRfOStn4&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-11-15T00%3A00%3A00%2B00%3A00&subject=Excelencia%20Live%202023">*/}
        {/*            <img*/}
        {/*                alt="Outlook Icon"*/}
        {/*                src="https://res-h3.public.cdn.office.net/owamail/20230630004.04/resources/images/favicons/mail-seen.ico"*/}
        {/*                style={{display: "inline-block", height: "1.8em", width: "1.8em", verticalAlign: "middle", border: 0, margin: "-0.4em 0", padding: 0, outline: 0}}*/}
        {/*            />&nbsp; &nbsp;Add to Outlook Calendar*/}
        {/*        </Button>*/}
        {/*    </ButtonContainer>*/}
        {/*</Container>*/}
      </Section>

      <Section className="blue-pattern-bkg">
        <Container>
          <VimeoVideo videoId="884997511" title="Excelencia Live 2023 REPLAY" size="large" />
          <p style={{fontWeight: "600", marginTop: "1rem", marginBottom: 0}}>
            During Excelencia Live we announced the winners of The CEM Prize for Portraiture.<br className="desktop-only" /> <Link to="/prize-for-portraiture/" css={css`text-decoration: underline; color: var(--lighterblue); &:hover {color: var(--lightblue)}`}>Click here</Link> to see the winners and view the entries in our digital gallery space.
          </p>
        </Container>
      </Section>

      <HostSection>
        <Container>
          <h2>Introducing our student hosts</h2>
          <div className="speakers">
            <div className="speaker">
              <img src={TobyImage} alt="Excelencia Live 2023 Host: Toby Tiongson"/>
              <h3>Toby Tiongson</h3>
              <p>
                Meet Toby, a Year 10 ACC Marsden Park On Campus student. He’s a music enthusiast with an infectious beat. His playlist features favourites like Ed Sheeran, Clinton Kane and CityAlight, and you can often find him drumming to their tunes. But it's not just music that strikes a chord with Toby; he's also passionate about his church’s youth group and food, with a special place in his heart for delectable meat pies.
              </p>
            </div>
            <div className="speaker">
              <img src={AshleyImage} alt="Excelencia Live 2023 Host: Ashley Gubat"/>
              <h3>Ashley Gubat</h3>
              <p>
                Meet Ashley Gubat, a Year 10 ACC Marsden Park On Campus student. When she’s not hanging with her friends or serving on the volleyball court, Ashley’s passion for music takes centre stage hitting those high notes. When she’s not rocking out or smashing volleyballs, Ashley loves spending quality time with God. She’s the go-to source for inspiration and good vibes.
              </p>
            </div>
          </div>
        </Container>
      </HostSection>

      <Section className="blue-pattern-bkg">
        <Container>
          <p style={{marginBottom: 0}}>
            <b>Whether it be STEM, Creative Arts, Short Stories, Essays, Drama, Poetry, Song or Social Sciences, Excelencia Live provides an opportunity for our learning community to witness some incredible student work.</b>
          </p>
        </Container>
      </Section>
      {/*<Section>*/}
      {/*  <Container>*/}
      {/*    <WatchPartyTitle>Upload your watch-party photos</WatchPartyTitle>*/}
      {/*    <Button*/}
      {/*      href="https://drive.google.com/drive/folders/1z2Ewbvl_4xrcgMQty2gipbiGIo1zc0L8?usp=sharing"*/}
      {/*      target="_blank" rel="noopener"*/}
      {/*      size="medium"*/}
      {/*      style={{margin: "0 auto 1.75rem", fontWeight: "600"}}>*/}
      {/*      <img src={GoogleDriveIcon} alt="Google Drive" style={{display: "inline-block", margin: "-0.3em 0.1em -0.4em 0", height: "1.em", width: "1.6em"}}/> Upload here*/}
      {/*    </Button>*/}
      {/*    <WatchPartyImage*/}
      {/*      image={data.watchPartyImage.childImageSharp.gatsbyImageData}*/}
      {/*      alt="Classroom of Medowie Christian School students watching Excelencia Live"*/}
      {/*      objectPosition={"5% 50%"}*/}
      {/*    />*/}
      {/*    <p style={{textAlign: "right", fontSize: "90%"}}><i>Sign-in to Google required.</i></p>*/}
      {/*  </Container>*/}
      {/*</Section>*/}

    </PageLayout>
  )

}

export default ExcelenciaLivePage

export function Head() {
  return (
    <HeadSeo
      title="Excelencia Live 2023"
      description="Excelencia Live is a special online event, hosted by students for students, showcasing short presentations from the talented individuals featured in the annual Excelenica printed journal."
      metaImage={EventImage}
    />
  )
}


// TODO remove topSectionContent query from graphql if it stays unused
export const query = graphql`
  query {
    featureImage:  file(relativePath: {eq: "images/excelencia-live/2023/feature-chicken-girl.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: BLURRED
          formats: [AUTO, WEBP]
          quality: 95
        )
      }
    }
#    watchPartyImage:  file(relativePath: {eq: "images/excelencia-live/2023/excelencia-watch-party.jpg"}) {
#      childImageSharp {
#        gatsbyImageData(
#          layout: FULL_WIDTH
#          placeholder: BLURRED
#          formats: [AUTO, WEBP]
#          quality: 95
#        )
#      }
#    }
  }
`
